import Button from '../../../components/base/Button';

const heroImage = {
  src: '/images/hero/1.webp',
  alt: 'AbschleppDirekt24 – Abschleppfahrzeug im Einsatz in Berlin'
};

export default function HeroSection() {
  const handleWhatsAppClick = () => {
    if (typeof window === 'undefined') return;
    window.open('https://wa.me/4915214468574', '_blank', 'noopener,noreferrer');
  };

  return (
    <section
      id="hero"
      className="relative min-h-[100svh] overflow-hidden bg-[#07111F] pt-24 pb-14 md:pt-36 md:pb-24"
    >
      <div className="absolute inset-0">
        <img
          src={heroImage.src}
          alt={heroImage.alt}
          className="absolute inset-0 h-full w-full object-cover object-center"
          loading="eager"
          fetchPriority="high"
          decoding="async"
          draggable={false}
        />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(7,17,31,0.94)_0%,rgba(7,17,31,0.82)_42%,rgba(7,17,31,0.52)_68%,rgba(7,17,31,0.72)_100%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_24%,rgba(56,189,248,0.16),transparent_34%),radial-gradient(circle_at_78%_68%,rgba(96,165,250,0.12),transparent_28%)]" />
      </div>

      <div className="relative z-10 mx-auto grid max-w-7xl gap-8 px-5 sm:px-6 lg:grid-cols-[minmax(0,1.1fr)_minmax(320px,0.9fr)] lg:items-end">
        <div className="max-w-3xl">
          <div className="inline-flex w-full max-w-full items-center gap-2 rounded-[1.75rem] border border-[#38BDF8]/30 bg-white/5 px-4 py-3 backdrop-blur-xl sm:w-auto sm:max-w-fit sm:rounded-full sm:py-2">
            <span className="mt-0.5 inline-flex h-2.5 w-2.5 shrink-0 rounded-full bg-[#38BDF8] shadow-[0_0_18px_rgba(56,189,248,0.9)] sm:mt-0" />
            <span className="min-w-0 text-[0.62rem] leading-[1.35] font-semibold uppercase tracking-[0.16em] text-[#D7F0FF] sm:text-[0.68rem] sm:tracking-[0.24em]">
              AbschleppDirekt24 · Berlin · 24/7 Einsatzbereit
            </span>
          </div>

          <h1 className="mt-5 text-[2.65rem] font-semibold leading-[0.98] text-white sm:text-5xl md:text-6xl xl:text-[4.6rem]">
            Abschleppdienst in Berlin.
            <span className="mt-1.5 block text-[#7DD3FC]">Sofort erreichbar. Direkt vor Ort.</span>
          </h1>

          <p className="mt-4 max-w-2xl text-[0.98rem] leading-relaxed text-[#D7E8F8] sm:text-lg md:text-xl">
            Pannendienst, Fahrzeugbergung und Falschparker-Abschleppung in Berlin & Umgebung. Schnelle Reaktionszeit, klare Kommunikation und direkter Kontakt ohne unnötige Umwege.
          </p>

          <div className="mt-5 grid gap-2.5 sm:grid-cols-3 sm:gap-4 max-w-2xl">
            <div className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3.5 backdrop-blur-xl">
              <p className="text-[0.7rem] uppercase tracking-[0.18em] text-[#7DD3FC]">24/7</p>
              <p className="mt-1.5 text-[0.92rem] font-medium text-white">Rund um die Uhr erreichbar</p>
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3.5 backdrop-blur-xl">
              <p className="text-[0.7rem] uppercase tracking-[0.18em] text-[#7DD3FC]">Berlin</p>
              <p className="mt-1.5 text-[0.92rem] font-medium text-white">Alle Bezirke + Umland</p>
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3.5 backdrop-blur-xl">
              <p className="text-[0.7rem] uppercase tracking-[0.18em] text-[#7DD3FC]">Direkt</p>
              <p className="mt-1.5 text-[0.92rem] font-medium text-white">Ohne Hotline-Umwege</p>
            </div>
          </div>

          <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <Button
              href="tel:+4915214468574"
              size="lg"
              className="w-full sm:w-auto px-6 sm:px-8 py-4 rounded-2xl bg-[#38BDF8] !text-[#07111F] border border-[#7DD3FC]/80 tracking-[0.08em] sm:tracking-[0.14em] uppercase hover:bg-[#7DD3FC] shadow-[0_18px_40px_rgba(56,189,248,0.28)] hover:shadow-[0_24px_55px_rgba(56,189,248,0.38)] text-sm sm:text-base max-w-full"
            >
              <svg
                aria-hidden="true"
                viewBox="0 0 24 24"
                className="mr-3 h-5 w-5 shrink-0 text-[#07111F]"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.35 1.78.68 2.62a2 2 0 0 1-.45 2.11L8.03 9.97a16 16 0 0 0 6 6l1.52-1.26a2 2 0 0 1 2.11-.45c.84.33 1.72.56 2.62.68A2 2 0 0 1 22 16.92z" />
              </svg>
              Jetzt anrufen
            </Button>

            <Button
              onClick={handleWhatsAppClick}
              size="lg"
              className="w-full sm:w-auto px-6 sm:px-8 py-4 rounded-2xl bg-white/8 backdrop-blur-2xl text-white border border-white/15 tracking-[0.08em] sm:tracking-[0.14em] uppercase hover:bg-white/12 shadow-[0_14px_35px_rgba(0,0,0,0.28)] text-sm sm:text-base max-w-full"
            >
              <svg
                aria-hidden="true"
                viewBox="0 0 24 24"
                className="mr-3 h-5 w-5 shrink-0 text-white"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M16.67 7.33a5 5 0 0 1-7.07 7.07L7 17l3.6-1.2a5 5 0 0 1 6.07-8.47z" />
                <path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z" />
              </svg>
              WhatsApp schreiben
            </Button>
          </div>
        </div>

        <div className="relative hidden lg:justify-self-end lg:block">
          <div className="rounded-[2rem] border border-white/10 bg-white/[0.06] p-5 backdrop-blur-2xl shadow-[0_30px_90px_rgba(0,0,0,0.35)] md:p-6">
            <div className="rounded-[1.6rem] border border-[#38BDF8]/20 bg-[linear-gradient(180deg,rgba(255,255,255,0.08),rgba(255,255,255,0.03))] p-5 md:p-6">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <p className="text-[0.68rem] uppercase tracking-[0.22em] text-[#7DD3FC]">Soforthilfe</p>
                  <h2 className="mt-2 text-2xl font-semibold text-white md:text-3xl">Schnelle Hilfe im Einsatzfall</h2>
                </div>
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-3xl bg-[#38BDF8] text-[#07111F] shadow-[0_12px_30px_rgba(56,189,248,0.35)]">
                  <i className="ri-flashlight-line text-2xl" />
                </div>
              </div>

              <div className="mt-6 space-y-3">
                <div className="rounded-2xl border border-white/8 bg-[#07111F]/40 px-4 py-4">
                  <p className="text-sm font-medium text-white">Pannenhilfe & Fahrzeugbergung</p>
                  <p className="mt-1 text-sm leading-relaxed text-white/65">Schnell vor Ort bei Defekten, Unfällen und nicht fahrbereiten Fahrzeugen.</p>
                </div>
                <div className="rounded-2xl border border-white/8 bg-[#07111F]/40 px-4 py-4">
                  <p className="text-sm font-medium text-white">Falschparker auf Privatgrund</p>
                  <p className="mt-1 text-sm leading-relaxed text-white/65">Dokumentierte Abschleppung blockierender Fahrzeuge auf privaten Flächen.</p>
                </div>
                <div className="rounded-2xl border border-white/8 bg-[#07111F]/40 px-4 py-4">
                  <p className="text-sm font-medium text-white">24/7 Hilfe in Sonderfällen</p>
                  <p className="mt-1 text-sm leading-relaxed text-white/65">Unterstützung auch bei Tiefgaragen, blockierten Zufahrten und schwierigen Einsatzsituationen.</p>
                </div>
              </div>

              <div className="mt-6 grid grid-cols-2 gap-3">
                <div className="rounded-2xl border border-white/8 bg-white/5 px-4 py-4 text-center">
                  <p className="text-2xl font-semibold text-white">24/7</p>
                  <p className="mt-1 text-[0.7rem] uppercase tracking-[0.18em] text-[#7DD3FC]">Erreichbar</p>
                </div>
                <div className="rounded-2xl border border-white/8 bg-white/5 px-4 py-4 text-center">
                  <p className="text-2xl font-semibold text-white">Berlin</p>
                  <p className="mt-1 text-[0.7rem] uppercase tracking-[0.18em] text-[#7DD3FC]">Einsatzgebiet</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}